"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=7%3A349))
 * @lastsynced 2026-10-29T13:49:45.154Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const ChevronDown = createSVGIcon(
  <path
    d="m3 9 8.51 8.79A.7.7 0 0 0 12 18a.67.67 0 0 0 .49-.21L21 9"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "ChevronDown",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    color: iconColor.primary,
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
